// extracted by mini-css-extract-plugin
export var tosLink = "_7k-0";